module.exports = __webpack_public_path__ + "static/component_preview@2x-de5b062ae56b1f31a2998afa90a67f08.png";